import { render, staticRenderFns } from "./SpecialistGuidesMenu.vue?vue&type=template&id=01c44cd3"
import script from "./SpecialistGuidesMenu.vue?vue&type=script&lang=js"
export * from "./SpecialistGuidesMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports